package com.example.readingnotes.presentation.admin

sealed interface AdminPostEditorEvent {
    // Existing events
    data class OnTitleChanged(
        val text: String,
    ) : AdminPostEditorEvent

    data class OnContentChanged(
        val text: String,
    ) : AdminPostEditorEvent

    data class OnImageUrlChanged(
        val text: String,
    ) : AdminPostEditorEvent

    data object OnSubmit : AdminPostEditorEvent

    data object OnReset : AdminPostEditorEvent

    // New events for edit/delete
    data class OnLoadPost(
        val id: String,
    ) : AdminPostEditorEvent

    data class OnUpdatePost(
        val id: String,
    ) : AdminPostEditorEvent

    data class OnDeletePost(
        val id: String,
    ) : AdminPostEditorEvent

    data class OnChangeStatus(
        val id: String,
        val status: String,
    ) : AdminPostEditorEvent

    data class OnStatusChanged(
        val status: String,
    ) : AdminPostEditorEvent

    // Image management events
    data object OnSelectImage : AdminPostEditorEvent

    data class OnImageSelected(
        val fileName: String,
        val mimeType: String,
        val imageData: ByteArray,
    ) : AdminPostEditorEvent

    data class OnUploadImage(
        val fileName: String,
        val mimeType: String,
        val imageData: ByteArray,
    ) : AdminPostEditorEvent

    data class OnImagePreview(
        val url: String,
    ) : AdminPostEditorEvent

    data class OnImageUploadError(
        val message: String,
    ) : AdminPostEditorEvent

    data class OnRemoveImage(
        val imageId: String,
    ) : AdminPostEditorEvent

    data class OnEditImage(
        val imageId: String,
    ) : AdminPostEditorEvent

    // TOTP for sensitive operations
    data class OnTotpCodeChanged(
        val code: String,
    ) : AdminPostEditorEvent

    data object OnConfirmDelete : AdminPostEditorEvent

    data object OnCancelDelete : AdminPostEditorEvent
}
